// extracted by mini-css-extract-plugin
export default {"infocard":"Everypermission_infocard__o9TQE"};